import getLang from 'I18n/utils/getLang';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useLocation } from 'quartz-routing/react-router';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { Paths } from '../../constants/paths';
import { useProductTypes } from '../../hooks/useProductTypeSearchParams';
import { DATA_TYPE_MAP } from '../utils/searchMappers';
const CROSS_SEARCH_TIMEOUT_MS = 10000;

/**
 * Fetches the solutions partner result count for cross-search linking.
 * Active when the current page is not already showing solutions partners.
 */
export function useSolutionsPartnerCrossSearchCount() {
  var _result$data;
  const location = useLocation();
  const searchParams = useSearchParams();
  const search = searchParams.get('search');
  const productTypes = useProductTypes();
  const isSolutionsPage = location.pathname === Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS;
  const includesSolutionsPartners = productTypes.includes('SOLUTIONS_PARTNER_PROFILE');
  const shouldFetch = !!search && !isSolutionsPage && !includesSolutionsPartners;
  const filter = {
    filterGroups: [{
      filtersByField: {
        PRODUCT_TYPE: [{
          values: ['SOLUTIONS_PARTNER_PROFILE'],
          clause: 'OR',
          negation: false,
          __typename: DATA_TYPE_MAP.STRING
        }]
      },
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
  const result = useAppContextQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      context: {
        timeout: CROSS_SEARCH_TIMEOUT_MS
      },
      skip: !shouldFetch,
      variables: {
        filter,
        length: 1,
        offset: 0,
        search: search || '',
        language: getLang()
      }
    }
  });
  if (!shouldFetch) {
    return {
      count: undefined,
      shouldShow: false
    };
  }
  return {
    count: (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.result.total,
    shouldShow: result.data !== undefined
  };
}